import React from 'react';
import { HEALTH_DISCLAIMER, offer } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="bg-mint-800 py-20 sm:py-28" aria-labelledby="cierre-title" data-id="element-94" data-mp="19ez1nd4q3826">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-95" data-mp="19cuoe4kxowp8">
        <Reveal data-id="element-96" data-mp="15caurazkkb7u">
          <h2 id="cierre-title" className="font-display text-3xl leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-97" data-mp="15bsp5nr0okn9">
            Puedes seguir buscando información suelta o empezar hoy con una ruta
            ordenada.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-mint-100" data-id="element-98" data-mp="1t2yaujjn275h">
            Todo el material en PDF, organizado por etapas para que sepas qué hacer
            en cada momento de la ruta de 15 días.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-99" data-mp="2245z08sfxrlu">
          <div className="mt-12 rounded-3xl bg-white px-8 py-10 sm:px-12" data-id="element-100" data-mp="221a0ojcol0wv">
            <p className="text-sm font-semibold text-mint-700" data-id="element-101" data-mp="1x6curlap77o7">{offer.label}</p>
            <p className="mt-3 text-[15px] text-ink-soft" data-id="element-102" data-mp="n6w7h09dnscq">
              6 tomos + ruta de hábitos de 15 días + 50 recetas + 5 bonos
            </p>
            <p className="mt-5 font-display text-5xl text-ink" data-id="element-103" data-mp="x3s70ghat455">{offer.price}</p>
            <div className="mt-7" data-id="element-104" data-mp="x5v5zq0fi7m0">
              <CtaButton data-id="element-105" data-mp="122liy4gxsn37">{offer.ctaSecondary}</CtaButton>
            </div>
            <p className="mt-5 text-xs text-ink-muted" data-id="element-106" data-mp="120in33t3rzqk">
              Pago seguro · Archivos PDF, sin envíos físicos · Garantía de 7 días
            </p>
            <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-ink-muted" data-id="element-107" data-mp="1b2i6g2rlbfwo">
              {HEALTH_DISCLAIMER}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}